<script lang="ts" setup>
import TreeNode from "./treeNode.vue";
import { answer, pptNode } from "../use/data";

const props = defineProps({
  disabled: {
    type: Boolean,
    required: false,
  },
});
const { disabled } = toRefs(props);

const formattingFun1 = () => {
  const content = `${answer.value}`;
  const splitStr = content.replaceAll("\n\n", "\n").split(`\n## `);
  const nodeJson = {
    type: "theme",
    title: splitStr[0].replace("# ", "").replace("主标题：", ""),
    children: splitStr
      .splice(1, splitStr.length - 1)
      .filter((item: string) => item.indexOf("###") > -1)
      .map((headline: string) => {
        const splitHeadline = headline.split(`\n### `);
        const headlineData = {
          type: "headline",
          title: splitHeadline[0].replace("副标题：", ""),
          children: splitHeadline
            .splice(1, splitHeadline.length - 1)
            .map((nodule) => {
              if (nodule.indexOf("####") > -1) {
                const splitNodule = nodule.split(`\n#### `);
                const noduleData = {
                  type: "nodule",
                  title: splitNodule[0].replace("子标题：", ""),
                  children: splitNodule
                    .splice(1, splitNodule.length - 1)
                    .map((text) => {
                      const splitText = text.split("\n");
                      return {
                        title: splitText[0]
                          .replace("小标题：", "")
                          .replace("观点：", "")
                          .replace("观点1：", "")
                          .replace("观点2：", "")
                          .replace("观点3：", "")
                          .replace("观点4：", ""),
                        text: splitText
                          .splice(1, splitText.length - 1)
                          .join("\n")
                          .replace("观点：", "")
                          .replace("观点1：", "")
                          .replace("观点2：", "")
                          .replace("观点3：", "")
                          .replace("观点4：", ""),
                      };
                    }),
                };
                return noduleData;
              } else {
                const splitNodule = nodule.split(`\n`);
                const noduleData = {
                  type: "nodule",
                  title: splitNodule[0].replace("子标题：", ""),
                  children: splitNodule
                    .splice(1, splitNodule.length - 1)
                    .map((text) => {
                      return {
                        title: "",
                        text: text
                          .replace("观点：", "")
                          .replace("观点1：", "")
                          .replace("观点2：", "")
                          .replace("观点3：", "")
                          .replace("观点4：", ""),
                      };
                    }),
                };
                return noduleData;
              }
            }),
        };
        return headlineData;
      }),
  };
  pptNode.value.splice(0, pptNode.value.length);
  pptNode.value.push(...[nodeJson]);
};

const formattingFun2 = () => {
  const content = `${answer.value}`;
  const splitStr = content.replaceAll("\n\n", "\n").split("\n# ");
  splitStr.splice(0, 1);
  const themeTitle = splitStr[0]?.split("\n## ")[0];
  splitStr.splice(0, 1);
  const nodeJson = {
    type: "theme",
    title: themeTitle,
    children: splitStr
      .filter((item: string) => item.indexOf("\n## ") > -1)
      .map((headline: string) => {
        const splitHeadline = headline.split(`\n## `);
        const headlineData = {
          type: "headline",
          title: splitHeadline[0].replace("副标题：", ""),
          children: splitHeadline
            .splice(1, splitHeadline.length - 1)
            .map((nodule) => {
              if (nodule.indexOf("\n###") > -1) {
                const splitNodule = nodule.split(`\n### `);
                const noduleData = {
                  type: "nodule",
                  title: splitNodule[0].replace("子标题：", ""),
                  children: splitNodule
                    .splice(1, splitNodule.length - 1)
                    .map((text) => {
                      const splitText = text.split("\n");
                      return {
                        title: splitText[0]
                          .replace("小标题：", "")
                          .replace("观点：", "")
                          .replace("观点1：", "")
                          .replace("观点2：", "")
                          .replace("观点3：", "")
                          .replace("观点4：", ""),
                        text: splitText
                          .splice(1, splitText.length - 1)
                          .join("\n")
                          .replace("观点：", "")
                          .replace("观点1：", "")
                          .replace("观点2：", "")
                          .replace("观点3：", "")
                          .replace("观点4：", ""),
                      };
                    }),
                };
                return noduleData;
              } else {
                const splitNodule = nodule.split(`\n`);
                const noduleData = {
                  type: "nodule",
                  title: splitNodule[0].replace("子标题：", ""),
                  children: splitNodule
                    .splice(1, splitNodule.length - 1)
                    .map((text) => {
                      return {
                        title: "",
                        text: text
                          .replace("观点：", "")
                          .replace("观点1：", "")
                          .replace("观点2：", "")
                          .replace("观点3：", "")
                          .replace("观点4：", ""),
                      };
                    }),
                };
                return noduleData;
              }
            }),
        };
        return headlineData;
      }),
  };
  pptNode.value.splice(0, pptNode.value.length);
  pptNode.value.push(...[nodeJson]);
};

if (answer.value.indexOf("###") > -1) formattingFun1();
else formattingFun2();
</script>

<template>
  <div class="w-full">
    <TreeNode :dataList="pptNode" :disabled="disabled" />
  </div>
</template>

<style lang="scss"></style>
